import React, { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import axios from "axios";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import images from "../../../constant/images";
import Header from "../../../layouts/header";

export const Conferences  = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [type, setType] = useState([]);

  useEffect(() => {
    const fetchBestOf = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/bestoftypes`, {
          params: {
            name: "Conferences",
          },
        });

        setType(response.data.type);

      } catch (err) {
        console.error(err);
      }
    };
    fetchBestOf();
    setIsLoading(false);
  }, [baseUrl]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState("");
  const navigationRefs = useRef({});

  const prevRef = useRef();
  const nextRef = useRef();
  const [swiperInstance, setSwiperInstance] = useState();



  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        <Header image={images.about} title="Conferences" />
        <div className="px-4 sm:px-8 lg:px-[10rem]">
          <p
            className="text-[#5a5a5a] text-base sm:text-lg lg:text-[20px] karla-font leading-relaxed tracking-wide"
            style={{ wordSpacing: "0.2rem" }}
          >
            <span className=" font-bold">
              {t("moroccanSunset.initiation.title")}
            </span>
            <span>{t("moroccanSunset.initiation.description")}</span>
            <br />
            <br />
            {t("moroccanSunset.hospitality")}
            <br />
            <br />
            <span className=" font-bold">
              {t("moroccanSunset.event.title")}
            </span>
            {t("moroccanSunset.event.description")}
          </p>
        </div>

        <div className="mt-[5rem] flex flex-col gap-[3rem] mb-10">
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
            </div>
          ) : type?.best_ofs?.length > 0 ? (
            <div className="space-y-12">
              <div className="flex flex-col gap-[2rem]">
                <h1 className="text-center fon text-4xl custom-font">
                  Best Of
                </h1>
              </div>
              <div className="space-y-8">
                <div className="relative px-4 sm:px-8 lg:px-16">
                  <button
                    ref={prevRef}
                    className="absolute top-1/2 left-[0px] transform -translate-y-1/2 z-10 text-2xl rounded-full  p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all"
                  >
                    <FaAngleLeft />
                  </button>

                  <button
                    ref={nextRef}
                    className="absolute top-1/2 right-[0px] transform -translate-y-1/2 z-10 text-2xl rounded-full  p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all"
                  >
                    <FaAngleRight />
                  </button>

                  <Swiper
                    spaceBetween={25}
                    loop={true}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      768: { slidesPerView: 2 },
                      1024: { slidesPerView: 3 },
                    }}
                    navigation={{
                      prevEl: prevRef?.current,
                      nextEl: nextRef?.current,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    onSwiper={setSwiperInstance}
                    className="w-full"
                  >
                    {type.best_ofs?.sort(
                        (a, b) =>
                          new Date(b.created_at) - new Date(a.created_at)
                      )
                      ?.map((item) => (
                        <div key={item.id}>
                          <SwiperSlide>
                        <div className="border bg-[#ebebeb] border-black p-4 relative group h-full">
                          <div className="video-container relative h-96 w-full">
                            <video
                              className="video-background absolute inset-0 w-full h-full object-cover"
                              loop
                              muted
                            >
                              <source src={item.url} type="video/mp4" />
                            </video>

                            <div className="video-overlay absolute inset-0 bg-black bg-opacity-60"></div>

                            <div className="absolute inset-0 flex items-center justify-center">
                              <div
                                className="w-16 h-16 cursor-pointer transition-transform duration-300 group-hover:scale-110"
                                onClick={() => {
                                  setVideo(item.url);
                                  setIsModalOpen(true);
                                }}
                              >
                                <svg
                                  viewBox="0 0 24 24"
                                  fill="white"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M8 5v14l11-7z" />
                                </svg>
                              </div>
                            </div>
                          </div>

                          <h3 className="mt-4 text-center text-lg font-medium">
                            {item.name}
                          </h3>
                          <h3 className="mt-4 text-center text-lg font-medium">
                            {item.date}
                          </h3>
                        </div>
                      </SwiperSlide>
                                              </div>

                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center "></div>
          )}
        </div>
        {isModalOpen && (
          <div className="modal fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="modal-video relative lg:max-w-[80vw] lg:h-[80vh]  bg-white">
              <button
                className="modal-close absolute -top-12 right-0 text-white text-3xl"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
              <video className="w-full h-full" controls autoPlay src={video}>
                <source src={video} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
